import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import Container from '@minecraft.container';
import Row from '@minecraft.row';
import Col from '@minecraft.col';
import { CoreTheme, media } from '@minecraft.themes';
import GlobalStyles from '@minecraft.global-styles';
import ProfileView from '@blocs.profile-view';
import { AppType } from '@blocs.common';
import Header from 'src/components/core/Header';
import { AppGlobalStyles } from 'components/styles/Common';

const StyledContainer = styled(Container)`
  background-color: ${(props): string => props.theme.colors.primary.white};
  padding: 2rem 0 0 0;
  max-width: 1440px;
  margin: 0 auto;
  ${media.xsm`
    padding: 1rem;
  `}
  ${media.sm`
    padding: 2rem;
  `}
`;

const StyledPage = styled.div`
  overflow: hidden;
  height: 100%;
  color: ${(props): string => props.theme.colors.primary.black};
  ${media.md`
    overflow: auto;
  `}
`;

type Props = {
  guid: string;
};

const PublicProfile = ({ guid }: Props): JSX.Element => {
  return (
    <ThemeProvider theme={CoreTheme}>
      <>
        <GlobalStyles />
        <AppGlobalStyles />
        <StyledPage data-testid="public-profile-wrapper">
          <Header hideNavigation />
          <StyledContainer fluid>
            <Row>
              <Col>
                <ProfileView isPreview appType={AppType.Talent} guid={guid} isPublic hidePreviewButtons>
                  <ProfileView.Header />
                  <ProfileView.TopNav />
                  <ProfileView.Info />
                  <ProfileView.Media />
                  <ProfileView.Credits />
                  <ProfileView.Resume />
                  <ProfileView.Skills />
                  <ProfileView.OtherExperience />
                  <ProfileView.Sizes />
                </ProfileView>
              </Col>
            </Row>
          </StyledContainer>
        </StyledPage>
      </>
    </ThemeProvider>
  );
};

export default PublicProfile;
